import { render, staticRenderFns } from "./MarketingIndex.vue?vue&type=template&id=6cb3d3c4&scoped=true"
import script from "./MarketingIndex.vue?vue&type=script&lang=js"
export * from "./MarketingIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketingIndex.vue?vue&type=style&index=0&id=6cb3d3c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb3d3c4",
  null
  
)

export default component.exports